module.exports = __webpack_public_path__ + "static/media/in_room_dining.f4d0f791.svg";